<div class="weather-legend" *ngIf="isVisible">
  <div class="legend-title" [innerHTML]="getWeatherLegendTitleHtml()"></div>

  <!-- Gradient Scale -->
  <div *ngIf="isGradientWeatherLayer"
       class="weather-scale-gradient"
       [class.temperature-gradient]="weatherLayerBaseName.includes('temperature') || weatherLayerBaseName.includes('frost')"
       [class.wide-legend]="needsWideLegend">
    <div class="gradient-bar" [class]="'gradient-' + weatherLayerBaseName">
      <div class="gradient-labels">
        <span *ngFor="let item of getWeatherLegendItems()"
              class="gradient-label">{{ item.value + ' ' }}</span>
      </div>
    </div>
  </div>

  <!-- Discrete Scale -->
  <div *ngIf="isDiscreteScaleWeatherLayer" class="weather-scale">
    <div class="legend-item" *ngFor="let item of getWeatherLegendItems()">
      <div class="color-box" [style.background]="item.color"></div>
      <span class="legend-value">{{ getTranslatedValue(item.value) }}</span>
    </div>
  </div>
</div>
